import { useLocation } from "react-router-dom";

export default function useLayout() {
  const { pathname } = useLocation();
  // ...
  return pathname === "/";
}
